interface ButtonProps {
    className?: string | undefined;
    style?: React.CSSProperties | undefined;
    onClick?: React.MouseEventHandler<any> | undefined;
    currentSlide?: number | undefined;
    slideCount?: number | undefined;
    children: React.ReactNode;
}

const SlickButton = ({ currentSlide, slideCount, children, ...props }: ButtonProps) => {
    return (
        <span {...props}>{children}</span>
    )
}

export default SlickButton;